/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ClientView,
    ClientViewFromJSON,
    ClientViewFromJSONTyped,
    ClientViewToJSON,
    FirmView,
    FirmViewFromJSON,
    FirmViewFromJSONTyped,
    FirmViewToJSON,
} from './';

/**
 * 
 * @export
 * @interface UserInfo
 */
export interface UserInfo {
    /**
     * 
     * @type {string}
     * @memberof UserInfo
     */
    id?: string;
    /**
     * 
     * @type {FirmView}
     * @memberof UserInfo
     */
    firm?: FirmView;
    /**
     * 
     * @type {ClientView}
     * @memberof UserInfo
     */
    client?: ClientView;
}

export function UserInfoFromJSON(json: any): UserInfo {
    return UserInfoFromJSONTyped(json, false);
}

export function UserInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'firm': !exists(json, 'firm') ? undefined : FirmViewFromJSON(json['firm']),
        'client': !exists(json, 'client') ? undefined : ClientViewFromJSON(json['client']),
    };
}

export function UserInfoToJSON(value?: UserInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'firm': FirmViewToJSON(value.firm),
        'client': ClientViewToJSON(value.client),
    };
}


